import "./components.css";
export const Container = (props: {
    children?: React.ReactElement<any, any>[] | React.ReactElement<any, any>;
    className?: string;
}) => {
    return <div className={props.className ? `container ${props.className}` : "container"}>
        {props.children}
    </div>
}